import Navbar from "@/components/landing/Navbar";
import ThreeSecrets from "@/components/landing/ThreeSecrets";
import ContentCTA from "@/components/landing/ContentCTA";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import CalendlySection from "@/components/landing/CalendlySection";
import ClosingCTA from "@/components/landing/ClosingCTA";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

const MandamientosPage = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <div className="pt-20" />
      <ThreeSecrets />
      <ContentCTA />
      <AboutUs />
      <Stats />
      <Testimonials />
      <CalendlySection />
      <ClosingCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default MandamientosPage;
